export const CONTENT_PRODUCT_CARD_IMG_SIZES = [136, 181, 204, 292];
export const PRODUCT_CARD_IMAGE_SIZE = 334;
export const SMALL_PRODUCT_CARD_IMAGE_SIZE = 250;
export const WISHLIST_BUTTON_SIZE = [32, null, null, 40];

export const LABELS_POSITION_TOP = ['sp_12', null, null, 'sp_20'];
export const LABELS_POSITION_LEFT = ['sp_8', null, null, 'sp_16'];

export const DEFAULT_PRODUCTS_ABOVE_THE_FOLD = 6;
export const HIGH_PRIORITY_IMAGE_COUNT = 3;
